import DebugActions from "./DebugActions";

export default DebugActions;